import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface RecentWonOpportunity {
  account_id: string;
  account_name: string;
  opportunity_id: string;
  opportunity_name: string;
  close_date: string;
  total_amount: number;
}

/**
 * Hook for fetching accounts with recent first-time won opportunities
 * @param days The number of days to look back (default: 30)
 * @param limit The maximum number of results to return (default: 10)
 */
export function useRecentFirstTimeWonOpportunities(
  days: number = 30,
  limit: number = 10,
) {
  return useQuery<RecentWonOpportunity[]>({
    queryKey: [
      "datahub",
      "opportunities",
      "recent-first-time-won",
      { days, limit },
    ],
    queryFn: async () => {
      const params = new URLSearchParams({
        days: days.toString(),
        limit: limit.toString(),
      });

      return api.get<RecentWonOpportunity[]>(
        `datahub/opportunities/recent-first-time-won/?${params}`,
      );
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
